import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import PutAwayDetailBoardActions, {
  PutAwayDetailBoardTypes
} from '../Stores/PutAwayDetailBoard/Actions';

const getAppStore = state => state.app;

export function* putAwayDetailBoardFetchWipGdsRcpt({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(PutAwayDetailBoardActions.putAwayDetailBoardFetchWipGdsRcptLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `gdsRcpt/indexToDoPutAway/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        PutAwayDetailBoardActions.putAwayDetailBoardFetchWipGdsRcptSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayDetailBoardActions.putAwayDetailBoardFetchWipGdsRcptLoading(false));
  }
}

export function* putAwayDetailBoardFetchWipPutAway({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(PutAwayDetailBoardActions.putAwayDetailBoardFetchWipPutAwayLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `putAway/indexToDoWhseJob/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        PutAwayDetailBoardActions.putAwayDetailBoardFetchWipPutAwaySuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayDetailBoardActions.putAwayDetailBoardFetchWipPutAwayLoading(false));
  }
}

export function* putAwayDetailBoardFetchWipWhseJob({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(PutAwayDetailBoardActions.putAwayDetailBoardFetchWipWhseJobLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `whseJob/indexToDoPutAway/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        PutAwayDetailBoardActions.putAwayDetailBoardFetchWipWhseJobSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayDetailBoardActions.putAwayDetailBoardFetchWipWhseJobLoading(false));
  }
}

export function* putAwayDetailBoardFetchCompletePutAway({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(PutAwayDetailBoardActions.putAwayDetailBoardFetchCompletePutAwayLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `putAway/indexTodayCompleted/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        PutAwayDetailBoardActions.putAwayDetailBoardFetchCompletePutAwaySuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayDetailBoardActions.putAwayDetailBoardFetchCompletePutAwayLoading(false));
  }
}

export function* putAwayDetailBoardShowWipGdsRcptSummary({ docId }) {
  try {
    yield put(PutAwayDetailBoardActions.putAwayDetailBoardShowWipGdsRcptSummaryLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `gdsRcpt/showSummary/${docId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(
        PutAwayDetailBoardActions.putAwayDetailBoardShowWipGdsRcptSummarySuccess(result.data)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayDetailBoardActions.putAwayDetailBoardShowWipGdsRcptSummaryLoading(false));
  }
}

export function* putAwayDetailBoardShowWipPutAwaySummary({ docId }) {
  try {
    yield put(PutAwayDetailBoardActions.putAwayDetailBoardShowWipPutAwaySummaryLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `putAway/showSummary/${docId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(
        PutAwayDetailBoardActions.putAwayDetailBoardShowWipPutAwaySummarySuccess(result.data)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayDetailBoardActions.putAwayDetailBoardShowWipPutAwaySummaryLoading(false));
  }
}

export function* putAwayDetailBoardShowWipWhseJobSummary({ docId }) {
  try {
    yield put(PutAwayDetailBoardActions.putAwayDetailBoardShowWipWhseJobSummaryLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `whseJob/showPutAwaySummary/${docId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(
        PutAwayDetailBoardActions.putAwayDetailBoardShowWipWhseJobSummarySuccess(result.data)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayDetailBoardActions.putAwayDetailBoardShowWipWhseJobSummaryLoading(false));
  }
}

export function* putAwayDetailBoardShowCompletePutAwaySummary({ docId }) {
  try {
    yield put(PutAwayDetailBoardActions.putAwayDetailBoardShowCompletePutAwaySummaryLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `putAway/showSummary/${docId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(
        PutAwayDetailBoardActions.putAwayDetailBoardShowCompletePutAwaySummarySuccess(result.data)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayDetailBoardActions.putAwayDetailBoardShowCompletePutAwaySummaryLoading(false));
  }
}

export const saga = [
  takeLatest(
    PutAwayDetailBoardTypes.PUT_AWAY_DETAIL_BOARD_FETCH_WIP_GDS_RCPT,
    putAwayDetailBoardFetchWipGdsRcpt
  ),

  takeLatest(
    PutAwayDetailBoardTypes.PUT_AWAY_DETAIL_BOARD_FETCH_WIP_PUT_AWAY,
    putAwayDetailBoardFetchWipPutAway
  ),

  takeLatest(
    PutAwayDetailBoardTypes.PUT_AWAY_DETAIL_BOARD_FETCH_WIP_WHSE_JOB,
    putAwayDetailBoardFetchWipWhseJob
  ),

  takeLatest(
    PutAwayDetailBoardTypes.PUT_AWAY_DETAIL_BOARD_FETCH_COMPLETE_PUT_AWAY,
    putAwayDetailBoardFetchCompletePutAway
  ),

  takeLatest(
    PutAwayDetailBoardTypes.PUT_AWAY_DETAIL_BOARD_SHOW_WIP_GDS_RCPT_SUMMARY,
    putAwayDetailBoardShowWipGdsRcptSummary
  ),

  takeLatest(
    PutAwayDetailBoardTypes.PUT_AWAY_DETAIL_BOARD_SHOW_WIP_PUT_AWAY_SUMMARY,
    putAwayDetailBoardShowWipPutAwaySummary
  ),

  takeLatest(
    PutAwayDetailBoardTypes.PUT_AWAY_DETAIL_BOARD_SHOW_WIP_WHSE_JOB_SUMMARY,
    putAwayDetailBoardShowWipWhseJobSummary
  ),

  takeLatest(
    PutAwayDetailBoardTypes.PUT_AWAY_DETAIL_BOARD_SHOW_COMPLETE_PUT_AWAY_SUMMARY,
    putAwayDetailBoardShowCompletePutAwaySummary
  )
];
